import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Abbreviation} from "../../models/abbreviation";
import Helpers from "../../utils/helpers";

@Injectable()
export class AbbreviationControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getAbbreviationList(): Observable<Abbreviation[]> {
    return this.http.get(this.baseUrl + "abbreviation") as Observable<Abbreviation[]>;
  }

  public createAbbreviation(abbreviation: Abbreviation): Observable<Abbreviation> {
    Helpers.trimRecursiveObj(abbreviation);
    const body = JSON.stringify(abbreviation);
    return this.http.post(this.baseUrl + "abbreviation", body) as Observable<Abbreviation>;
  }

  public updateAbbreviation<T>(abbreviation: Abbreviation) {
    Helpers.trimRecursiveObj(abbreviation);
    const body = JSON.stringify(abbreviation);
    return this.http.put(this.baseUrl + "abbreviation", body, {responseType: "text"});
  }

}
